import React, {useState, useEffect} from 'react'
import {get_user_detail} from "../apis/index";
import { Helmet } from 'react-helmet'
import Sidebar from '../components/sidebar'
import SubscriptionItem from "../components/subscription"
import './subscription.css'

const Subscription = (props) => {
  const [user_detail, setUser_detail] = useState({accounts: []})

  useEffect(() => {
    const onLoad = async () => {
      let user_data = await get_user_detail();
      if (user_data) {
        console.log(user_data);
        setUser_detail(user_data);
      }
    };

    onLoad();
  }, []);


  return (
    <div className="subscription-container">
      <Helmet>
        <title>subscription - wapi</title>
        <meta property="og:title" content="subscription - wapi" />
      </Helmet>
      <div className="subscription-container01">
        <Sidebar rootClassName="sidebar-root-class-name3"></Sidebar>
        <div className="subscription-container02">
          <div className="subscription-header">
            <div className="subscription-container03">
              <div className="subscription-container04">
                <h3 className="subscription-text">Subscriptions</h3>
              </div>
              <div className="subscription-container05">
                <span>Available Credit: 0</span>
                <button className="subscription-button button">
                  Top up Credit
                </button>
              </div>
              {/* <button className="subscription-button1 button">
                manage cards
              </button> */}
            </div>
          </div>
          <div className="subscription-body">
            {user_detail.accounts.length === 0 && (
              <div className="subscription-container06">
                <div className="subscription-container07">
                  <span className="subscription-text02">
                    No Active Subscriptions
                  </span>
                </div>
              </div>
            )}
           
          {/* subscription stuffs here */}
          {user_detail.accounts.map((account) => (
              <SubscriptionItem key={account.account_id} account={account} />
            ))}

          </div>
        </div>
      </div>
      <div className="subscription-choosepayment">
        <div className="subscription-paymentcontainer">
          <div className="subscription-paymentitem">
            <h3 className="subscription-text23">Select Payment Method</h3>
            <svg viewBox="0 0 1024 1024" className="subscription-icon">
              <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
            </svg>
          </div>
          <div className="subscription-paymentitem1">
            <div className="subscription-container20">
              <div className="subscription-container21">
                <input
                  type="radio"
                  name="radio"
                  checked
                  className="subscription-radiobutton"
                />
                <h3 className="subscription-text24">Card</h3>
              </div>
              <div className="subscription-container22">
                <button className="subscription-button4 button">
                  Add New Card
                </button>
              </div>
            </div>
            <div className="subscription-container23">
              <div className="subscription-container24">
                <div className="subscription-container25">
                  <h4 className="subscription-text25">
                    MasterCard ending 2344
                  </h4>
                </div>
                <div className="subscription-container26">
                  <span>Expiring  03/2026</span>
                </div>
              </div>
              <button className="subscription-button5 button">Select</button>
            </div>
            <div className="subscription-container27">
              <div className="subscription-container28">
                <div className="subscription-container29">
                  <h4 className="subscription-text27">
                    MasterCard ending 2344
                  </h4>
                </div>
                <div className="subscription-container30">
                  <span>Expiring  03/2026</span>
                </div>
              </div>
              <button className="subscription-button6 button">Select</button>
            </div>
          </div>
          <div className="subscription-paymentitem2">
            <input
              type="radio"
              name="radio"
              checked
              className="subscription-radiobutton1"
            />
            <h3 className="subscription-text29">Crypto</h3>
          </div>
          <div className="subscription-paymentitem3">
            <div className="subscription-container31">
              <h4 className="subscription-text30">Top Up Amount</h4>
            </div>
            <div className="subscription-container32">
              <div className="subscription-container33">
                <h4 className="subscription-text31">$</h4>
              </div>
              <div className="subscription-container34">
                <input
                  type="number"
                  value="0"
                  placeholder="0"
                  className="subscription-textinput input"
                />
              </div>
            </div>
          </div>
          <div className="subscription-paymentitem4">
            <button className="subscription-button7 button">Cancel</button>
            <button className="subscription-button8 button">Proceed</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Subscription
